import {
  FETCH_DELETE_OWNER_REQUEST,
  FETCH_DELETE_OWNER_SUCCESS,
  FETCH_DELETE_OWNER_FALUIRE,
} from './deleteOwnerByOwnerIDTypes'

const initialState = {
  loading: false,
  deleteOwnerInfo: null,
  error: '',
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DELETE_OWNER_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_DELETE_OWNER_SUCCESS : return {
      ...state,
      deleteOwnerInfo: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_DELETE_OWNER_FALUIRE : return {
      ...state,
      loading: false,
      deleteOwnerInfo: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
